import React, { Component } from 'react'
import * as languageSettings from '../components/Language/languageSettings'
import StoreDetailsAdmin from '../components/Stores/StoreDetailsAdmin'
import StoreDetailsClient from '../components/Stores/StoreDetailsClient'
import { initStoresDetails, adminStoresDetails } from '../actions/stores'
import { getCompanyLBVersion, getAccountSubscriptionType } from '../actions/leaderboard'
import { getPermission } from '../actions/roles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AuthenticationService from '../components/Security/AuthenticationService'
import { Config } from '../Config'
import CommonLoader from '../components/Alerts/CommonLoader'
// StoreDetails - Component.
class StoreDetails extends Component {
  constructor (props) {
    super(props)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      showCommonLoader: true,
      profile: this.authService.getProfile()
    }
    this.renderStoreList = this.renderStoreList.bind(this)
  }

  // get data from localstorage using react lifecycle method with loader function
  componentWillMount () {
    if (window.localStorage.getItem('storeListShowCommonLoader')) {
      this.setState({ showCommonLoader: false })
    } else {
      window.localStorage.setItem('storeListShowCommonLoader', true)
    }
    this.props.getCompanyLBVersion()
    this.props.getAccountSubscriptionType()
    this.props.getPermission()
    if (!this.authService.isAdmin()) {
      this.props.initStoresDetails(() => {
        this.setState({ showCommonLoader: false })
      })
    } else {
      this.props.adminStoresDetails(() => {
        this.setState({ showCommonLoader: false })
      })
    }
  }

  // check authService
  renderStoreList () {
    if (!this.authService.isAdmin()) {
      //  user is not admin
      let isSubscribed = this.props.companyLBV ? (this.props.companyLBV.LeaderboardMode_ID ? (this.props.companyLBV.LeaderboardMode_ID === 2) : false) : false
      return <StoreDetailsClient subscriptionType={this.props.subscriptionType} showStores={!this.authService.isAdmin()} userProfile={this.state.profile} stores={this.props.storesDetails} history={this.props.history} userPermissions={this.props.roles.userPermission} LeaderboardMode_ID={isSubscribed} />
    } else {
      //  user isAdmin
      return <StoreDetailsAdmin showStores={this.authService.isAdmin()} userProfile={this.state.profile} stores={this.props.storesDetails} history={this.props.history} />
    }
  }
  // Displaying the list of Stores based on user( Admin / normal user)
  render () {
    return (
      <div>
        {this.state.showCommonLoader
          ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
          : this.renderStoreList()
        }
      </div>
    )
  }
}

// get the data from Redux state function
function mapStateToProps (state) {
  return {
    books: state.books,
    storesDetails: state.storeDetails,
    companyLBV: state.companyLBVersion.companyLBVersion,
    subscriptionType: state.accountSubscriptionType.accountSubscriptionType,
    roles: state.roles
  }
}

// Redux actions
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      initStoresDetails: initStoresDetails,
      adminStoresDetails: adminStoresDetails,
      getCompanyLBVersion: getCompanyLBVersion,
      getAccountSubscriptionType: getAccountSubscriptionType,
      getPermission: getPermission
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(StoreDetails)



// WEBPACK FOOTER //
// ./src/containers/StoreDetails.js